$(document).ready(function () {
    $('[data-toggle="popover"]').tooltip({
        items: "[data-content]",
        content: function () {
            var element = $(this);
            if (element.is("[data-content]")) {
                return element.attr("data-content");
            }
        },
        position: {
            my: "center bottom-20",
            at: "center top"
        },
        open: function (event, ui) {
            ui.tooltip.animate({ bottom: ui.tooltip.position().bottom + 10 }, "fast");
        },
        hide: {
            delay: 1000
		},
		close: function (event, ui) {
			ui.tooltip.hover(
				function () {
					$(this).stop(true).fadeTo(400, 1);
				},
				function () {
					$(this).fadeOut("400", function () { $(this).remove(); })
				}
			);
		}
    });

    $('[data-toggle="popover"]').on("click", function (e) {
        $(this).tooltip("open");
    });
});